import { createSlice, isAnyOf } from "@reduxjs/toolkit"
import { RetrievePlatformDataType } from "src/interfaces/Platform.interface"
import { retrivePlatformDataAsync } from "../actions/platformActions"

type retrivePlatformPayload={
    retrivedPlatformData: RetrievePlatformDataType | null
    retrivedPlatformLoading: boolean
}

const initialState: retrivePlatformPayload ={
    retrivedPlatformData:null,
    retrivedPlatformLoading:false,
}

const retrivePlatformDataSlice =createSlice({
    name: 'retrivedPlatformDataSlice',
    initialState,
    extraReducers: (builder) => {
      builder.addMatcher(isAnyOf(retrivePlatformDataAsync.pending), (state, action) => {
        state.retrivedPlatformLoading = true
      })
      builder.addMatcher(isAnyOf(retrivePlatformDataAsync.fulfilled), (state, action) => {
      
        state.retrivedPlatformData = action?.payload
        state.retrivedPlatformLoading = false
      })
      builder.addMatcher(isAnyOf(retrivePlatformDataAsync.rejected), (state) => {
        state.retrivedPlatformLoading = false
      })
    },
    reducers: {
        setRetrivedPlatformData: () => initialState,
    },

});

export const {setRetrivedPlatformData} = retrivePlatformDataSlice.actions
export default retrivePlatformDataSlice.reducer;